import { render, staticRenderFns } from "./show-more.vue?vue&type=template&id=5445643e&scoped=true&"
import script from "./show-more.vue?vue&type=script&lang=js&"
export * from "./show-more.vue?vue&type=script&lang=js&"
import style0 from "./show-more.vue?vue&type=style&index=0&id=5445643e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445643e",
  null
  
)

export default component.exports